export default __webpack_public_path__ + "static/media/bg_4.2fd5d6b5.png";